<script>
    import Logo from "../components/Logo.svelte";
    import Button from "../components/Button.svelte";
    import {links} from "../links";
</script>

<footer>
    <div style="margin-bottom: 20px; display: flex; justify-content: center">
        <Button icon="images/index/下载.svg" link={links.增值服务} text="增值服务" />
    </div>
    <div class="content">
        <Logo/>
        <div class="about-us">
            《红宝书》APP是一款《【红宝书】考研英语词汇（必考词+基础词+超纲词）》书籍的配套学习软件。《红宝书》APP依托《【红宝书】考研英语词汇》丰富的内容和科学系统的编排体例，设计出一套严谨、高效、符合大脑记忆规律的考研英语词汇学习记忆方法。
            《红宝书》APP是对《【红宝书】考研英语词汇》功能的延伸和扩展，极大的方便了用户更好地学习记忆考研英语词汇。
        </div>
    </div>
    <div class="social" style="padding: 32px 112px">
        <div style="margin-bottom: 18px">关注我们</div>
        <div style="display: flex">
            <div>
                <img class="footer-qr" src="images/index/公众号QR@2x.png">
                <div style="margin-top: 6px">微信公众号</div>
            </div>

            <div style="margin-left: 56px">
                <img class="footer-icon" src="images/index/微博@1x.svg">
            </div>
        </div>

    </div>

    <div class="footer-legal">
        <div class="legal-text">
            <a href={links.备案} target="_blank">陕ICP备08006712号-1</a>&nbsp;&nbsp;|&nbsp;&nbsp;Copyright ©
            2013 - 2022 红宝书版权所有
        </div>
    </div>
</footer>

<style>
    .content {
        background: #212122;
        padding: 12px 12px 0 18px;
    }

    footer a {
        color: white;
        text-decoration: white;
    }

    .social {
        display: none;
    }

    .footer-legal {
        background: #292828;
        height: 48px;
        padding: 6px 18px;
        border-top: 1px solid #6a6a6a;
    }
    .about-us {
        margin-top: 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 1.2;
        color: white;
        width: 125%;
        transform-origin: left top;
        transform: scale(calc(8 / 12));
    }
    .legal-text {
        font-weight: 400;
        white-space: nowrap;
        transform-origin: left;
        transform: scale(calc(9 / 12));
        font-size: 12px;
        line-height: 1.2;
        color: white;
    }

    .footer-qr {
        width: 116px;
    }

    .footer-icon {
        width: 48px;
    }
</style>
